/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entityfiltertype2Inputs */

const en_entity_entityfiltertype2 = /** @type {(inputs: Entity_Entityfiltertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Filter Type`)
};

const de_entity_entityfiltertype2 = /** @type {(inputs: Entity_Entityfiltertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätenfilter-Typ`)
};

/**
* | output |
* | --- |
* | "Entity Filter Type" |
*
* @param {Entity_Entityfiltertype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entityfiltertype2 = /** @type {((inputs?: Entity_Entityfiltertype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entityfiltertype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entityfiltertype2(inputs)
	return de_entity_entityfiltertype2(inputs)
});
export { entity_entityfiltertype2 as "entity_entityFilterType" }